import $ from 'jquery';

$(function() {
  new Swiper ('.skills-slider', {
      autoplay: {
          delay: 5000,
      },
      loop: true,
      breakpoints: {
          320: {
              slidesPerView: 1,
              spaceBetween: 20
          },
          480: {
              slidesPerView: 2
          },
          768: {
              slidesPerView: 3
          },
          1024: {
              slidesPerView: 4
          },
          1366: {
              slidesPerView: 5
          },
          1600: {
              slidesPerView: 6
          }
      }
  })
});

